import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { LogoutDialog as View } from './view'

export const LogoutDialog = {
    View: reflect({
        view: View,
        bind: {
            onConfirm: model.logoutConfirmed,
        },
    }),
    model,
}

model.showFx.use(modalOpener(LogoutDialog.View))
